window.KFBiography =
  window.KFBiography ||
  (() => {
    const init = () => {
      const elements = document.querySelectorAll<HTMLElement>('.kf-o-biography');

      if (!elements.length) return;

      elements.forEach((block) => {
        const empNumber = block.dataset.employeeNumber;

        if (typeof empNumber === 'undefined') return;

        const personalInfoAreaEl = block.querySelector<HTMLInputElement>('.PersonInfoArea');

        if (personalInfoAreaEl) {
          personalInfoAreaEl.value = empNumber;
        }
      });
    };

    window.addEventListener('load', init);

    return {};
  })();

export {};
